import { Injectable } from '@angular/core';

@Injectable()
export class ScriptLoaderService {
  // this script service is an injectable service that handles loading script files
  // https://stackoverflow.com/questions/37729896/how-to-load-a-3rd-party-script-from-web-dynamically-into-angular2-component

  scripts = [
    { name: 'tableau', src: 'https://public.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js' }
  ];

  private scriptsToLoad: any = {};

  constructor() {
    this.scripts.forEach(script => {
      this.scriptsToLoad[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: string[]) {
    var promises: any[] = [];
    scripts.forEach(script => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (this.scriptsToLoad[name].loaded) {
        let childToRemove = document.getElementById(name);
        if (childToRemove) {
          document.getElementsByTagName('head')[0].removeChild(childToRemove);
        }
      }

      // load script
      let script = document.createElement('script');
      // script.type = 'text/javascript';
      script.type = 'module'
      script.id = name;
      script.src = this.scriptsToLoad[name].src;

      script.onload = () => {
        this.scriptsToLoad[name].loaded = true;
        resolve({ script: name, loaded: true, status: 'Loaded' });
      };

      script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/script-loader.service.ts